import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';
import { CARRERAS_CONST } from '../carreras/CarrerasService';

export const DEPORTES_CONST = 'deportes';
export const JUEGOS_DEPORTIVOS_CONST = 'juegos_deportivos';

export const deportesApi = `${baseUrl}/${DEPORTES_CONST}`;
export const juegosDeportivosApi = `${baseUrl}/${JUEGOS_DEPORTIVOS_CONST}`;

export const allDeportesService = async (params) => {
  const res = await axios.get(deportesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveDeportesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${deportesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(deportesApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneDeportesService = async (id) => {
  const res = await axios.get(`${deportesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteDeportesService = async (id) => {
  const res = await axios.delete(`${deportesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const asignarCarreraDeportesService = async (idCarrera, idMateria) => {
  const res = await axios.post(
    `${baseUrl}/${CARRERAS_CONST}/${idCarrera}/${DEPORTES_CONST}/${idMateria}`,
    {},
    { headers: token({}) },
  );
  return res;
};

export const deleteCarreraDeportesService = async (idCarrera, idMateria) => {
  const res = await axios.delete(
    `${baseUrl}/${CARRERAS_CONST}/${idCarrera}/${DEPORTES_CONST}/${idMateria}`,
    { headers: token({}) },
  );
  return res;
};
